/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Message to Remove an existing Creative from an order line
*/
export class RemoveCreativeRequest {
    'orgId': string;
    'creativeId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "creativeId",
            "baseName": "creative_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return RemoveCreativeRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

